// Quelle: /opt/webgis/frontend/src/app/Footer.tsx (Stand 2026-09-29)
// Geändert (SPEC 03 §7.2.3): Logo 18 px, „Handschrift · LILASp“, Fassung aus health.version
// (mono), „Nur mit LILASp-Anmeldung · KI lokal auf GEX44“ (TX.shell.fussZugang — seit E18
// öffentlich mit Anmeldung + Turnstile, nicht mehr nur im VPN). Keine Verweise nach draußen.
import { useQuery } from "@tanstack/react-query";
import { holeHealth } from "../../api/client";
import { Icon } from "../ui";
import { TX } from "../../lib/texte";
import { Logo } from "./Logo";

export function Footer() {
  const { data: health } = useQuery({ queryKey: ["health"], queryFn: holeHealth, staleTime: 60_000 });
  return (
    <footer className="fuss">
      <Logo hoehe={18} />
      <span>{TX.shell.fuss}</span>
      {health?.version && (
        <span className="mono" translate="no" style={{ fontSize: 11.5 }}>
          {health.version}
        </span>
      )}
      <span className="fuss-rechts">
        <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
          <Icon name="shield-check" size={14} />
          {TX.shell.fussZugang}
        </span>
      </span>
    </footer>
  );
}
